import { Payee } from '@/payee.model';
import { AdminUserCreate } from '@/admin/admin-user.model';
import { API } from 'aws-amplify';

export function useAdmin() {
  return {
    createPayeeAdmin,
    savePayeeAdmin,
    deletePayeeAdmin,
  }
}

function createPayeeAdmin(payee: Payee, payeeAdmin: AdminUserCreate) {
  return API.post('API', `/v1/payees/${payee.id}/admin`, { body: payeeAdmin });
}

function savePayeeAdmin(payee: Payee, payeeAdmin: AdminUserCreate) {
  return API.put('API', `/v1/payees/${payee.id}/admin/${payeeAdmin.id}`, { body: payeeAdmin });
}

function deletePayeeAdmin(payee: Payee, payeeAdminId: string) {
  return API.del('API', `/v1/payees/${payee.id}/admin/${payeeAdminId}`, {});
}
